import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { stripUnit } from 'polished'

import SectionComponent from '../Section'

import fluidRange from '../../utils/fluidRange'
import { WidthContainer, ColorDeterminer } from '../../utils/helpers.styles'

export const Section = styled(SectionComponent)(
  WidthContainer,
  ColorDeterminer,
  ({ theme }) => css`
    ${fluidRange('padding-top', [
      stripUnit(theme.spacing.md),
      stripUnit(theme.spacing.md),
    ])};
    ${fluidRange('padding-bottom', [
      stripUnit(theme.spacing.md),
      stripUnit(theme.spacing.md),
    ])};
  `
)

export const Content = styled.div(
  ({ theme, layout, mobileImage, hasBackgroundImage }) => css`
    display: flex;
    gap: 15px;

    * {
      margin-bottom: 0;
      margin-top: 0;
      margin-left: 0;
      margin-right: 0;
    }

    ${hasBackgroundImage && `position: relative;`}

    .image-container {
      ${layout === '10/90' && 'flex: 1;'}
      ${layout === '20/80' && 'flex: 2;'}
      ${layout === '50/50' && 'flex: 5;'}
      ${layout === '100' && 'display: none;'}

      .svg-image svg {
        width: fit-content;
      }
    }

    .text-content {
      ${layout === '10/90' && 'flex: 9;'}
      ${layout === '20/80' && 'flex: 8;'}
      ${layout === '50/50' && 'flex: 5;'}
      display: flex;
      gap: ${theme.spacing.sm};
      flex-direction: column;
    }

    @media (min-width: 541px) {
      .mobile-image {
        display: none;
      }
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      flex-direction: column;

      .desktop-image {
        ${mobileImage && 'display: none;'}
      }

      .image-container {
        ${layout !== '50/50' && layout !== '100' && 'width: 50%;'}

        .svg-image {
          justify-content: flex-start;
        }
      }
    }
  `
)

export const TextContent = styled.div(
  ({ theme, centerAligned, contentAlignment }) => css`
    flex: 8;

    ${contentAlignment === 'Top' && 'align-self: flex-start;'}
    ${contentAlignment === 'Center' && 'align-self: center;'}
    ${contentAlignment === 'Bottom' && 'align-self: flex-end;'}

    @media (min-width: ${theme.breakpoints.sm}) {
      ${centerAligned &&
      `
        align-items: center;
        display: flex;
        flex-direction: column;
        text-align: center;

        .label { text-align: left; }
      `}
    }
  `
)

export const ImageContainer = styled.div(
  ({ imageAlignment }) => css`
    ${imageAlignment === 'Top' && 'align-self: flex-start;'}
    ${imageAlignment === 'Center' && 'align-self: center;'}
    ${imageAlignment === 'Bottom' && 'align-self: flex-end;'}
  `
)

export const BGImage = styled.div`
  display: block;
  position: absolute !important;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  // In decoupling from Gatsby image, i need to target the inline styles generated by gatsby on that div
  > .gatsby-image-wrapper {
    position: initial !important;

    // Gatsby Image has inline-styles with padding-bottom overflow into other sections.
    > div {
      padding-bottom: 0 !important;
    }

    picture {
      img {
        height: 100%;
      }
    }
  }

  > img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`

export const BackgroundImage = styled(BGImage)`
  ${(props) =>
    props.mobileBackgroundImage &&
    `
    @media (max-width: 539px) {
      display: none;
    }
  `}
`

export const MobileBackgroundImage = styled(BGImage)`
  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    display: none;
  }
`
